module.exports = __webpack_public_path__ + "static/media/PT.94016cd9.png";